/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Arrow from 'components/Icons/Arrow/Arrow';
import scrollTo from 'utils/scrollTo';
import './Hint.scss';

/**
 * This is the Hint component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Hint({ title, target, alignTop, ...props }) {
  function onClick() {
    if (target === null) {
      scrollTo(window, alignTop);
    } else {
      const targetElement = document.querySelector(target);
      if (targetElement) {
        scrollTo(targetElement, alignTop);
      }
    }
  }

  return (
    <button className="hint" onClick={onClick}>
      <Arrow className="animate-bounce" {...props} />
      <div>{title}</div>
    </button>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Hint.propTypes = {
  title: PropTypes.string.isRequired,
  target: PropTypes.string,
  alignTop: PropTypes.bool,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Hint.defaultProps = {
  title: null,
  target: null,
  alignTop: false,
};

export default Hint;
